import Vue from 'vue';

const EventBus = new Vue();

Object.defineProperties(Vue.prototype, {
  $ebus: {
    get() {
      return EventBus;
    },
  },
});

export default EventBus;
